
























// vue
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

// components
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import UsersRolesAndExceptionsList from '@/views/RolesAndPermissions/components/UsersRolesAndExceptionsList.vue';
import RoleExceptionFilterActionComponent from '@/views/RolesAndPermissions/components/RoleExceptionFilterActionComponent.vue';

// store
import {
  GetRolesAndExceptionsParams,
  PaginatedUserGroupsPermissions,
  UserPermissions,
  RoleUserInfo
} from '@/store/modules/role/types/role.types';
import { RootState } from '@/store/store';
import { SortOrder, PaginatorSpecs } from '@/store/types/general.types';
import { RoleExceptionFilter } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

@Component({
  components: {
    UsersRolesAndExceptionsList,
    BasePaginatorHoc,
    RoleExceptionFilterActionComponent
  }
})
export default class UserTab extends Vue {
  page: number = 1;
  perPage: number = 10;
  search: string = '';
  role: string = '';
  exception: string | null = '';
  totalCount: number = 0;
  sortOrder: SortOrder = SortOrder.ASC;
  users: RoleUserInfo[] = [];
  selectedFilterOption: RoleExceptionFilter = {
    search: '',
    role: '',
    exception: '',
    displayExceptionName: ''
  };

  get UsersRolesAndExceptionsList() {
    return UsersRolesAndExceptionsList;
  }

  @Action('role/getUserRolesAndExceptions')
  private getUserRolesAndExceptions!: (
    payload: GetRolesAndExceptionsParams
  ) => Promise<void>;

  @State(({ role }: RootState) => role.userRolesAndExceptions)
  private userRolesAndExceptions!: PaginatedUserGroupsPermissions;

  @State(
    ({ role }: RootState) => role.apiState.getUserRolesAndExceptions.success
  )
  private getUserRolesAndExceptionsSuccessState!: boolean;

  @Watch('getUserRolesAndExceptionsSuccessState')
  onGetUserRolesAndExceptionsSuccessState() {
    if (!this.getUserRolesAndExceptionsSuccessState) {
      this.users = [];
      return;
    }

    if (
      !this.userRolesAndExceptions ||
      this.userRolesAndExceptions.itemCount === 0 ||
      !this.userRolesAndExceptions.data ||
      this.userRolesAndExceptions.data.length === 0
    ) {
      this.users = [];
      return;
    }
    this.totalCount = +this.userRolesAndExceptions.totalItems;
    this.users = [];

    const usersData: UserPermissions[] = this.userRolesAndExceptions
      .data as UserPermissions[];
    usersData.map((user) => {
      const individualRoles: string[] = [];
      const groupRoles: string[] = [];
      const individualExceptions: string[] = [];
      const groupExceptions: string[] = [];

      for (const permission of user.permissions) {
        if (permission.type === 'role') {
          if (permission.source === 'individual') {
            // skip if already in individualRoles
            if (
              permission.roleName &&
              individualRoles.indexOf(permission.roleName) === -1
            ) {
              individualRoles.push(permission.roleName);
            }
          } else if (permission.roleName && permission.source === 'group') {
            // skip if already in groupRoles
            if (groupRoles.indexOf(permission.roleName) === -1) {
              groupRoles.push(permission.roleName);
            }
          }
        }
        if (permission.groupPermission) {
          const permissionName: string = permission.groupPermission;
          if (permission.type === 'exception') {
            if (permission.source === 'individual') {
              // skip if already in individualExceptions
              if (individualExceptions.indexOf(permissionName) === -1) {
                individualExceptions.push(permissionName);
              }
            } else if (permission.source === 'group') {
              // skip if already in groupExceptions
              if (groupExceptions.indexOf(permissionName) === -1) {
                groupExceptions.push(permissionName);
              }
            }
          }
        }
      }

      this.users.push({
        id: user.id,
        fullName: user.fullName,
        email: user.email,
        individualRoles,
        groupRoles,
        individualExceptions,
        groupExceptions
      });
    });
  }

  mounted() {
    this.sortOrder = SortOrder.ASC;
    this.getUserRolesAndExceptionsHandler();
  }

  paginateItems({ perPage, page }: PaginatorSpecs): void {
    this.perPage = perPage;
    this.page = page;
    this.getUserRolesAndExceptionsHandler();
  }

  public handleSort(data: any) {
    this.sortOrder = data.sortOrder;
    this.getUserRolesAndExceptionsHandler();
  }

  public handleFilter(filter: RoleExceptionFilter) {
    this.search = filter.search;
    this.role = filter.role;
    this.exception = filter.exception;
    this.page = 1;
    this.getUserRolesAndExceptionsHandler();
  }

  public handleResetFilter() {
    this.selectedFilterOption = {
      search: '',
      role: '',
      exception: '',
      displayExceptionName: ''
    };
    this.search = '';
    this.role = '';
    this.exception = '';
    this.getUserRolesAndExceptionsHandler();
  }

  getUserRolesAndExceptionsHandler() {
    const payload: GetRolesAndExceptionsParams = {
      page: this.page,
      limit: this.perPage,
      search: `%${this.search}%`,
      role: this.role,
      exception: this.exception,
      sortOrder: this.sortOrder
    };
    this.getUserRolesAndExceptions(payload);
  }
}
